import { api } from "./authService";

const schoolService = {
  // Alle Schulen abrufen
  getAllSchools: async (professionType = null) => {
    try {
      const params = {};
      if (professionType) {
        params.professionType = professionType;
      }
      const response = await api.get("/schools", { params });
      return response.data;
    } catch (error) {
      console.error("Error fetching schools:", error);
      throw error;
    }
  },

  // Alias für getAllSchools für Konsistenz
  getSchools: async () => {
    return schoolService.getAllSchools();
  },

  // Schule anhand ID abrufen
  getSchoolById: async (id) => {
    try {
      const response = await api.get(`/schools/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching school ${id}:`, error);
      throw error;
    }
  },

  // Neue Schule erstellen
  createSchool: async (schoolData) => {
    try {
      const response = await api.post("/schools", schoolData);
      return response.data;
    } catch (error) {
      console.error("Error creating school:", error);
      throw error;
    }
  },

  // Schule aktualisieren
  updateSchool: async (id, schoolData) => {
    try {
      const response = await api.put(`/schools/${id}`, schoolData);
      return response.data;
    } catch (error) {
      console.error(`Error updating school ${id}:`, error);
      throw error;
    }
  },

  // Schule löschen
  deleteSchool: async (id) => {
    try {
      await api.delete(`/schools/${id}`);
    } catch (error) {
      console.error(`Error deleting school ${id}:`, error);
      
      // Extract error message from backend response
      let errorMessage = error.message;
      if (error.response && error.response.data) {
        if (typeof error.response.data === 'string') {
          errorMessage = error.response.data;
        } else if (error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.response.data.error) {
          errorMessage = error.response.data.error;
        }
      }
      
      // Create a new error with the backend message
      const newError = new Error(errorMessage);
      newError.originalError = error;
      throw newError;
    }
  },

  // Schulen nach Namen suchen
  searchSchools: async (name) => {
    try {
      const response = await api.get(`/schools/search?name=${encodeURIComponent(name)}`);
      return response.data;
    } catch (error) {
      console.error("Error searching schools:", error);
      throw error;
    }
  },
};

export default schoolService;